import type { AccountInfo } from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';

export function useMsalAccount(): AccountInfo | null {
	const { accounts } = useMsal();
	return useAccount(accounts?.[0]);
}

export function useMsalAccountUsername(): string | undefined {
	const account = useMsalAccount();
	return account?.username;
}
